import axios from 'axios'
import Vue from 'vue'

let API_BASE = new Vue({
    data: () => ({
        conexiones: [],
        basicAuth: {
            usuario: 'Telefonica',
            contraseña: 'B0ZnhaihL8ZB'
        },
        Llamando: false,
        respuestaOK: '',
        respuestaError: '',
        respuestaConexion: ''
    }),
    created() {
        if (process.env.NODE_ENV === 'development') {
            this.conexiones.comun = axios.create({
                baseURL: 'https://localhost:30000/api/SmartLabs',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websat = axios.create({
                baseURL: 'https://localhost:30000/api/telefonica/webSat',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatRent = axios.create({
                baseURL: 'https://localhost:30000/api/telefonica/webSatRent',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatSuscripcion = axios.create({
                baseURL: 'https://localhost:30000/api/telefonica/webSatSuscripcion',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })

        } else if (window.location.href.includes("test")) {
            this.conexiones.comun = axios.create({
                baseURL: 'https://smartapi2test.smartlabs.es:30002/api/SmartLabs',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websat = axios.create({
                baseURL: 'https://smartapi2test.smartlabs.es:30002/api/telefonica/webSat',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatRent = axios.create({
                baseURL: 'https://smartapi2test.smartlabs.es:30002/api/telefonica/webSatRent',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatSuscripcion = axios.create({
                baseURL: 'https://smartapi2test.smartlabs.es:30002/api/telefonica/webSatSuscripcion',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
        } else if (window.location.href.includes("pruebas")) {
            this.conexiones.comun = axios.create({
                baseURL: 'http://smartapipruebas.smartlabs.es/api/SmartLabs',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websat = axios.create({
                baseURL: 'http://smartapipruebas.smartlabs.es/api/telefonica/webSat',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatRent = axios.create({
                baseURL: 'http://smartapipruebas.smartlabs.es/api/telefonica/webSatRent',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatSuscripcion = axios.create({
                baseURL: 'http://smartapipruebas.smartlabs.es/api/telefonica/webSatSuscripcion',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
        } else if (window.location.href.includes("http://websattelefonica.zeleris.com")) {
            this.conexiones.comun = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/SmartLabs',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websat = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/telefonica/webSat',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatRent = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/telefonica/webSatRent',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatSuscripcion = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/telefonica/webSatSuscripcion',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
        } else {
            this.conexiones.comun = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/SmartLabs',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websat = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/telefonica/webSat',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatRent = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/telefonica/webSatRent',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            })
            this.conexiones.websatSuscripcion = axios.create({
                baseURL: 'https://smartapi.zeleris.com/api/telefonica/webSatSuscripcion',
                headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64')}
            })
            //this.conexiones.comun = axios.create({
            //    baseURL: 'http://62.97.70.205/smartapi/api/SmartLabs',
            //    headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            //})
            //this.conexiones.websat = axios.create({
            //    baseURL: 'http://62.97.70.205/smartapi/api/telefonica/webSat',
            //    headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            //})
            //this.conexiones.websatRent = axios.create({
            //    baseURL: 'http://62.97.70.205/smartapi/api/telefonica/webSatRent',
            //    headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            //})
            //this.conexiones.websatSuscripcion = axios.create({
            //    baseURL: 'http://62.97.70.205/smartapi/api/telefonica/webSatSuscripcion',
            //    headers: { 'Authorization': 'Basic ' + Buffer.from(`${this.basicAuth.usuario}:${this.basicAuth.contraseña}`, 'utf8').toString('base64') }
            //}) 
        }
    },
    computed: { basicRequest() { return {} /* this.basicAuth */ } },
    methods: {
        //Mejora > si es un objeto reemplaza si es un array crea con los keys
        createRequest(parametrosRequest = {}, mostrarSpin = true) {
            if (mostrarSpin) this.Llamando = true
            return { ...this.basicRequest, ...parametrosRequest }
        },
        handleExito(respuesta, mostrarMensajeOK = true) {
            this.Llamando = false
            this.respuestaConexion = ''

            if (respuesta.data.token) this.tokenSesion = respuesta.data.token

            if (respuesta.data.codigo == 0) {
                if (mostrarMensajeOK) this.respuestaOK = respuesta.data.mensaje
                return respuesta.data
            } else {
                this.respuestaError = respuesta.data.mensaje
                return ''
            }
        },
        handleError(error, mostrarMensaje = true) {
            console.log('handler error' + mostrarMensaje + " - " + error)
            this.Llamando = false
            if (mostrarMensaje && error.message === 'Network Error') this.respuestaConexion = '¡ERROR! No se ha podido conectar con el servidor, contacte con nuestro soporte técnico'
            return ''
        }
    }
})
/******************************************* LLAMADAS A API *********************************************/
API_BASE.postCodes = function () {
    const SALIDA = API_BASE.conexiones.comun.post('/postCodes', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.getBasicData = function (keys) {
    // { keys: ['Modelos', 'Manufactures', 'Logistics', 'Symptoms', 'Accessories'] }
    const SALIDA = API_BASE.conexiones.websat.post('/getBasicData', API_BASE.createRequest(keys))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.getOrdenEstados = function (keys) {
    const SALIDA = API_BASE.conexiones.websat.post('/getOrdenEstados', API_BASE.createRequest(keys))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.login = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/login', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.registro = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/registro', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.comprobarCredenciales = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/comprobarCredenciales', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.cambiarPasswordParticular = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/cambiarPasswordParticular', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.comprobarCodigoPostal = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/comprobarCodigoPostal', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.newRepair = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/newRepair', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.getTienda = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/getTienda', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.expedicion = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/expedicion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.guardarFactura = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/guardarFactura', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.buscarOrden = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/buscarOrden', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.descargarInformeReparacion = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/descargarInformeReparacion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.descargarInformeIrreparable = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/descargarInformeIrreparable', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.descargarFactura = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/descargarFactura', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}



//Particulares con registro
API_BASE.getEmpresaCatalogo = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/getEmpresaCatalogo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.getIdTallerMapeo = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/getIdTallerMapeo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.recuperarPassword = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/recuperarPassword', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.comprobarTokenRecuperarPassword = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/comprobarTokenRecuperarPassword', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.cambiarPassword = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/cambiarPassword', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.getCatalogo = function (json) {
    const SALIDA = API_BASE.conexiones.websat.post('/getCatalogo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.getDNIsEmailsActivos = function () {
    const SALIDA = API_BASE.conexiones.websat.post('/getDNIsEmailsActivos', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.getTiendas = function (v) {
    const SALIDA = API_BASE.conexiones.websat.post('/obtenerTiendasPorCP', API_BASE.createRequest({ cp: v }))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.CodigosPrescriptores = function () {
    const SALIDA = API_BASE.conexiones.websat.post('/CodigosPrescriptores', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

//Suscripciones
API_BASE.loginCliente = function (json, mostrarMensaje = true) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/loginCliente', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, mostrarMensaje))
        .catch(error => API_BASE.handleError(error))
    return SALIDA
}

API_BASE.validarCodigo = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/validarCodigo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.getTipoSuscripcionesDisponibles = function () {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/getTipoSuscripcionesDisponibles', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.seleccionarTipoSuscripcion = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/seleccionarTipoSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.cobroSuscripcion = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/cobroSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error))
    return SALIDA;
}

API_BASE.cancelarSuscripcion = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/cancelarSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.reactivarRenovacion = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/reactivarRenovacion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.actualizarTarjeta = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/actualizarTarjeta', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

API_BASE.anularSuscripcion = function (json) {
    const SALIDA = API_BASE.conexiones.websatSuscripcion.post('/anularSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false))
    return SALIDA
}

//RENT
API_BASE.getDesplegables = function (json) {
    const SALIDA = API_BASE.conexiones.websatRent.post('/getDesplegables', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true))
    return SALIDA
}

API_BASE.resgistarIncidencia = function (json) {
    const SALIDA = API_BASE.conexiones.websatRent.post('/resgistarIncidencia', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true))
    return SALIDA
}

 API_BASE.consultarIncidencia = async function (json) {
    const SALIDA = API_BASE.conexiones.websatRent.post('/consultarIncidencia', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true))
    return SALIDA
}

API_BASE.getlineasPublicasEstados = function (json) {
    const SALIDA = API_BASE.conexiones.websatRent.post('/getlineasPublicasEstados', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true))
    return SALIDA
}

API_BASE.getEstados = function (json) {
    const SALIDA = API_BASE.conexiones.websatRent.post('/getlineasPublicasEstados', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true))
    return SALIDA
}

// INSTALAR API COMO THIS.$API EN TODOS LOS COMPONENTES
export default {
    install(Vue) {
        Vue.prototype.$API = API_BASE
    }
}